var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont",class:[_vm.iconClass, _vm.className],style:({ fontSize: _vm.size, color: _vm.color }),attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }